import { render } from "./FontSize.vue?vue&type=template&id=3b3746d0&scoped=true&ts=true"
import script from "./FontSize.vue?vue&type=script&lang=ts"
export * from "./FontSize.vue?vue&type=script&lang=ts"

import "./FontSize.vue?vue&type=style&index=0&id=3b3746d0&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3746d0"]])

export default __exports__